import React from "react";
import ReactDOM from "react-dom";
import { FilterContextProvider } from "./inclusion/podcast/filters-context";
import Filters from "./inclusion/podcast/filters";

const filtersApp = () => {
  return (
    <FilterContextProvider>
      <Filters />
    </FilterContextProvider>
  );
};

export const initPodcastFilters = () => {
  ReactDOM.render(filtersApp(), document.getElementById("podcast-filters"));
};
